import { useRouter } from "next/router";

/**
 * Hook to get tenantId from the current route
 * Assumes the route pattern: /v2/tenant/[tenantId]/...
 */
export default function useTenantId(): string | undefined {
  const router = useRouter();

  const tenantId = Array.isArray(router.query.tenantId)
    ? router.query.tenantId[0]
    : router.query.tenantId;

  return tenantId;
}
